module.exports = __webpack_public_path__ + "static/P2101556-99bdf3dd1ce80a069ffda87384766087.jpg";